import { PosCashier } from '@pos/app/scripts/services/pos-cashier';

/*
 * Service meant to centralize the intepretation of search input
 */
export class PosSearch {
  constructor(
    private pos,
    private posCashier: PosCashier,
  ) {}

  /**
   * @ngdoc service
   * @name posApp.scan
   * @description
   * Function that intreprets input form the search box
   */
  scan(input: string) {
    if (input.startsWith('..')) {
      return this.posCashier.scan(input);
    }

    return this.pos.onPosSearch(input);
  }
}

angular.module('posApp').factory('posSearch', (pos, posCashier) => {
  return new PosSearch(pos, posCashier);
});
